import { Menu as AntdMenu } from 'antd'

export const Menu = (props: any) => {
  return <AntdMenu {...props}>{props.children}</AntdMenu>
}
